module.exports = __webpack_public_path__ + "img/detailsliftgate-only-no.7ef122e4.svg";